@if (overlayService.isLoading()) {
  <lbt-loader
    size="xxlg"
    overlayColor="dark"
    overlayLabel="WORKING ..."
  />
}
<main class="main-layout d-flex">
  <aside class="main-sidebar">
    <lbt-main-menu></lbt-main-menu>
  </aside>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</main>

<ng-template #sessionExpiredTmpl>
  <lbt-confirmation
    okText='Sign back in'
    okType='primary'
    title="Your session has expired"
    [hideCancelBtn]='true'
    [showHeader]="true"
    [showCloseIcon]="false"
    [noDivider]="true"
    [confirmContent]='sessionExpiredTextTmpl'>
  </lbt-confirmation>
</ng-template>

<ng-template #sessionExpiredTextTmpl>
  <lbt-text typography="body1" color="gray-12">
    For your security, we log you out automatically when you have not been active for a certain period of time
  </lbt-text>
</ng-template>
